import * as React from 'react';
import * as Classes from '../common/classes';
import { Button } from '../button/Button';
import { Space } from '../space/Space';
import classNames from 'classnames';
import { SidePanelItem } from '../app/AppLayout';

type SidePanelMenuProps = {
  items: SidePanelItem[];
  currentKey?: string;
  onSelect: (key: string) => void;
  className?: string;
};

export const SidePanelMenu: React.FC<SidePanelMenuProps> = ({
  items,
  currentKey,
  onSelect,
  className,
}) => {
  return (
    <div>
      <Space
        className={classNames(Classes.NAVBAR_SIDEPANEL_CONTROLS, className)}
        vertical
      >
        {items.map((sidepanelButton, index) => (
          <div
            className={
              currentKey === sidepanelButton.key
                ? Classes.NAVBAR_SIDEPANEL_CONTROL_ACTIVE
                : Classes.NAVBAR_SIDEPANEL_CONTROL_BASIC
            }
            key={index}
          >
            <Button
              icon={sidepanelButton.icon}
              key={sidepanelButton.key}
              onClick={() => onSelect(sidepanelButton.key)}
              style={currentKey !== sidepanelButton.key ? 'link' : 'primary'}
              title={sidepanelButton.label}
            />
            {currentKey === sidepanelButton.key && (
              <div className={Classes.NAVBAR_SIDEPANEL_ACTIVE_INDICATOR} />
            )}
          </div>
        ))}
      </Space>
    </div>
  );
};
